import { useEffect, useState } from 'react';

// Below the `md` breakpoint (768px) the analytics pickers render as bottom
// sheets instead of trigger-anchored popovers (DS mobile). Kept in sync with
// Tailwind's `md` so the JS switch and the CSS layout flip at the same width.
const MOBILE_QUERY = '(max-width: 767px)';

function matches(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(matches);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
